import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../api';

export default function MyTimeOff() {
  const [balances, setBalances] = useState([]);
  const [requests, setRequests] = useState([]);
  const [policies, setPolicies] = useState([]);
  const [form, setForm] = useState(null);

  const load = () => {
    api('/hcm/my-pto-balances').then(r => r.ok ? r.json() : []).then(setBalances);
    api('/hcm/my-pto-requests').then(r => r.ok ? r.json() : []).then(setRequests);
    api('/hcm/my-pto-policies').then(r => r.ok ? r.json() : []).then(setPolicies);
  };
  useEffect(load, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await api('/hcm/my-pto-requests', {method: 'POST', body: JSON.stringify(form)});
    setForm(null);
    load();
  };

  const handleCancel = async (id) => {
    if (!window.confirm('Cancel this time off request?')) return;
    await api(`/hcm/my-pto-requests/${id}`, {method: 'DELETE'});
    load();
  };

  const statusBadge = (s) => {
    const cls = s === 'approved' ? 'bg-green-100 text-green-800' : s === 'denied' ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800';
    return <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${cls}`}>{s.charAt(0).toUpperCase() + s.slice(1)}</span>;
  };

  return (
    <Layout>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900">My Time Off</h2>
        {policies.length > 0 && (
          <button onClick={() => setForm({policyId: '', startDate: '', endDate: '', hours: '', notes: ''})}
            className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 text-sm">Request Time Off</button>
        )}
      </div>

      {balances.length > 0 && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          {balances.map(b => (
            <div key={b.id} className="bg-white rounded-lg shadow p-4">
              <p className="text-sm text-gray-500">{b.policyName}</p>
              <p className="text-2xl font-bold text-gray-900">{b.balance}h</p>
              <p className="text-xs text-gray-400">Used: {b.used}h</p>
            </div>
          ))}
        </div>
      )}

      <div className="bg-white rounded-lg shadow">
        <div className="p-4 border-b"><h3 className="font-semibold text-gray-900">My Requests</h3></div>
        {requests.length === 0 ? (
          <div className="text-center py-8 text-gray-500">No time off requests yet.</div>
        ) : (
          <div className="divide-y">
            {requests.map(r => (
              <div key={r.id} className="px-4 py-4">
                <div className="flex items-center gap-3 mb-1">
                  <span className="font-medium text-gray-900">{r.policyName}</span>
                  {statusBadge(r.status)}
                </div>
                <p className="text-sm text-gray-500">{r.startDate} to {r.endDate} · {r.hours}h</p>
                {r.notes && <p className="text-sm text-gray-400 italic mt-1">{r.notes}</p>}
                {r.status === 'pending' && (
                  <button onClick={() => handleCancel(r.id)} className="mt-2 text-xs text-red-600 hover:text-red-800">Cancel Request</button>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {form && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" onClick={() => setForm(null)}>
          <form onSubmit={handleSubmit} onClick={e => e.stopPropagation()} className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md space-y-4">
            <h3 className="text-lg font-semibold text-gray-900">Request Time Off</h3>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Type *</label>
              <select required value={form.policyId} onChange={e => setForm({...form, policyId: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg">
                <option value="">Select...</option>
                {policies.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
              </select>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Start Date *</label>
                <input type="date" required value={form.startDate} onChange={e => setForm({...form, startDate: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">End Date *</label>
                <input type="date" required value={form.endDate} onChange={e => setForm({...form, endDate: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg" />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Hours *</label>
              <input type="number" step="0.5" required value={form.hours} onChange={e => setForm({...form, hours: parseFloat(e.target.value)})} className="w-full px-3 py-2 border border-gray-300 rounded-lg" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Notes</label>
              <textarea value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} rows={2} className="w-full px-3 py-2 border border-gray-300 rounded-lg" />
            </div>
            <div className="flex justify-end gap-3">
              <button type="button" onClick={() => setForm(null)} className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg">Cancel</button>
              <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700">Submit</button>
            </div>
          </form>
        </div>
      )}
    </Layout>
  );
}
